import React, { useCallback, useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import './App.css';
import { GradientBackground } from './components/index';
import { router } from './Routes';
import { AuthProvider } from './module/AuthenticationModule';
import { AuthProvider as CoreAuthProvider } from './module/AuthContext';
import GlobalFonts from './asset/fonts/font';
import { useThemeContext } from './hook/useThemeManager';
import { theme } from './constants/theme';
import { toggleTheme } from './redux/appConfigurator/action';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { MessageContextProvider } from './module/MessageContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

function App() {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const dispatch = useDispatch();
    const { themeStyle, toggleView } = useThemeContext();

    const handleSetTheme = useCallback(() => {
        const isSet = localStorage.getItem('theme_toggled');
        if (mediaQuery.matches && !isSet) {
            dispatch(toggleTheme(mediaQuery.matches ? 'dark' : 'light'));
        }
    }, [mediaQuery.matches, dispatch]);

    useEffect(() => {
        handleSetTheme();
    }, [handleSetTheme]);

    useEffect(() => {
        const view = localStorage.getItem('view');

        if (view) toggleView(view);
    }, [toggleView]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <CoreAuthProvider>
                <GradientBackground
                    style={{
                        flex: 1,
                        alignItems: 'center',
                        width: '100%',
                        justifyContent: 'center',
                        height: '100%',
                        backgroundColor: theme[themeStyle].pure_black,
                    }}>
                    <AuthProvider>
                        <MessageContextProvider>
                            <Box
                                sx={{
                                    alignContent: 'center',
                                    flex: 1,
                                    overflow: 'hidden',
                                }}>
                                <GlobalFonts />
                                <RouterProvider router={router} />
                                <ToastContainer position="bottom-right" />
                            </Box>
                        </MessageContextProvider>
                    </AuthProvider>
                </GradientBackground>
            </CoreAuthProvider>
        </LocalizationProvider>
    );
}

export default App;
